import api from '@/utils/api';
import * as Constants from '@/constants';

export default {
  name: 'ProviderAutocomplete',
  props: ['service', 'showTooltip'],
  data() {
    return {
      // provider autocomplete
      providerSearchError: '',
      providerSearchInput: null,
      providerSearchLoading: false,
      providersArray: [],
      newProvider: ''
    };
  },
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    },
    isTablet() {
      return this.$mq === 'tablet';
    },
    isDesktop() {
      return this.$mq === 'laptop' || this.$mq === 'desktop';
    }
  },
  methods: {
    addNewProviderByStudent(pId) {
      if (pId || this.newProvider.userId) {
        const body = {
          serviceId: this.service.serviceId,
          providerUserId: pId || this.newProvider.userId
        };
        this.newProvider = null;
        api.post(Constants.ADD_PROVIDER_TO_STUDENT_SERVICE_AND_TEAM_URL(), body)
          .then(() => {
            // clear the array
            this.providersArray = [];
            this.$emit('update-services');
          });
      }
    },
    removeProviderByStudent(id) {
      this.showLoading = true;
      this.errorMsg = null;
      api.delete(Constants.REMOVE_PROVIDER_FROM_STUDENT_SERVICE_AND_TEAM_URL(id))
        .then(() => {
          this.$emit('update-services');
        });
    },
    // clears the dropdown values of the autocomplete when focusing on the field
    clearNewProviderAutoComplete() {
      if (!this.newProvider) {
        this.providersArray = [];
      }
    }
  },
  watch: {
    // fires the api call to get providers list
    providerSearchInput() {
      // show loading
      this.providerSearchLoading = true;
      // clear timeout if function is called before setTimeout fires
      clearTimeout(this.timeout);
      // make sure the user types something before firing request
      if (this.providerSearchInput) {
        // fire the request after a delay
        this.timeout = setTimeout(() => {
          api.get(Constants.ADD_NEW_PROVIDER_TO_SERVICE_URL(this.service.serviceId, this.providerSearchInput))
            .then((res) => {
              this.providersArray = res.data.data;
            })
            .catch((error) => {
              this.providerSearchError = error.message;
            })
            .finally(() => {
              // stop loading
              this.providerSearchLoading = false;
            });
        }, 300);
      } else {
        this.providerSearchLoading = false;
      }
    },
    // watcher for autocomplete model
    newProvider(newVal, oldVal) {
      // if newVal is undefined and there was an oldVal, clear the providers array
      if (!newVal && !!oldVal) this.providersArray = [];
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/agency-scheduler/add-by-student/add-new-provider-autocomplete.js